export const EMBEDDED_APP_STATES: Record<string, EmbeddedAppStates> = {
  INVALID_URL: 'INVALID_URL',
  LOADING: 'LOADING',
  READY: 'READY',
  UNAVAILABLE: 'UNAVAILABLE',
  UNPROCESSABLE: 'UNPROCESSABLE',
};

export const VALID_IFRAME_URL = window.__TB_CONFIG__.LAUNCH_PANEL.LOADER_URL;
